// Tiny start/stop rAF loop used by GameScene. Pulled out so the scene file
// stays inside the 200-line cap and so the loop's idempotency contract is
// captured in one place.

export class RafLoop {
  private id: number | null = null;
  constructor(private readonly tick: () => void) {}

  start(): void {
    if (this.id !== null) return;
    const frame = (): void => {
      this.id = requestAnimationFrame(frame);
      this.tick();
    };
    this.id = requestAnimationFrame(frame);
  }

  stop(): void {
    if (this.id === null) return;
    cancelAnimationFrame(this.id);
    this.id = null;
  }
}
